import { TabGroup as HeadlessTabGroup } from '@headlessui/react';
import Tab from './Tab';
import TabList from './TabList';
import TabPanel from './TabPanel';
import TabPanels from './TabPanels';

const Tabs = props => <HeadlessTabGroup {...props} />;

Tabs.List = TabList;
Tabs.Tab = Tab;
Tabs.Panels = TabPanels;
Tabs.Panel = TabPanel;

export default Tabs;
